import {Button, IconButton, TextareaAutosize, TextField} from "@mui/material"
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Box from "elements/Box";
import {ProjectConfig} from 'Global';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import EventIcon from '@mui/icons-material/Event';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import App from "elements/HtmlEditor/App";
import { useSnackbar, withSnackbar } from "notistack";
import LangTabs from "elements/LangTabs";



export default withSnackbar(
  function CelebracionesEditor(props : any) {

  /*SNACKBAR FUNCTION FOR NOTIFICATIONS*/
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  /*============================================= */
  
  /*=======================================
    GET SANTORAL ID FROM URL
  =======================================*/
  let {celebracion_id } = useParams();
  /*=======================================
  =======================================*/


  const navigate = useNavigate();
  const defaultValues: any = {
    celebracion_id: celebracion_id? celebracion_id : "null",
    title: "",
    contentHTML: "",
    contentJSON: null,
    date : null
  };

  
  const [loading, setLoading] = useState(false); 
  const [formValues, setFormValues] = useState(defaultValues)
  const [files, setFiles] = useState<any>([]);
  const [currentLangId, setCurrentLangId] = useState("1");
  const [translations, setTranslations] = useState<{[key: string]: {title: string, contentHTML: string, contentJSON: any}}>({});

  /*=======================================
    TEXT EDITOR STATE
  =======================================*/
  const [initialContent, setInitialContent] = useState<any>(null);


  // Helper to update translations
  const updateTranslation = (field: string, value: any) => {
    setTranslations(prev => ({
      ...prev,
      [currentLangId]: {
        ...prev[currentLangId],
        [field]: value
      }
    }));
  };

  // Handler for language change
  const handleLangChange = (newLangId: string) => {
    setCurrentLangId(newLangId);
    
    // Update editor content based on new language
    if (newLangId === "1") {
      setInitialContent(formValues.contentJSON);
    } else {
      const trans = translations[newLangId];
      setInitialContent(trans?.contentJSON || null);
    }
  };


  const handleInputChange = (e: { target: { name: any; value: any; }; }) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  // Get current title for selected language
  const getCurrentTitle = () => {
    if (currentLangId === "1") {
      return formValues.title;
    }
    return translations[currentLangId]?.title || "";
  };

  // Handle title change
  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (currentLangId === "1") {
      setFormValues({ ...formValues, title: value });
    } else {
      updateTranslation('title', value);
    }
  };


  /*=======================================
    TEXT EDITOR HANDLER
  =======================================*/

  const handleEditorChange = (htmlContent: any, jsonContent: any) => {
      if (currentLangId === "1") {
        setFormValues({
          ...formValues,
          contentHTML: htmlContent,
          contentJSON: jsonContent
        });
      } else {
        updateTranslation('contentHTML', htmlContent);
        updateTranslation('contentJSON', jsonContent);
      }
  }


  /*=======================================
  =======================================*/




  /*=======================================
    GET DETAILS IF EDITING
  =======================================*/
  useEffect(() => {
    if (celebracion_id) {
      axios
        .get(ProjectConfig.api_url, {
          params: {
            request: "celebraciones_details",
            id: celebracion_id,
          },
        })
        .then((response) => {
          console.log("formValues", response.data)
          setFormValues(response.data);
          setInitialContent(response.data.contentJSON);
          if (response.data.translations) {
            setTranslations(response.data.translations);
          }
        })
        .catch((err) => {
          console.log(err.data);
        });
    }
  }, []);
  /*=======================================
  =======================================*/

  


  /*=======================================
    SUBMIT
  =======================================*/
  const [progress, setProgress] = useState(0);

  const checkForm = () => {
    
    let errors = false

    if(formValues.title == ""){
      enqueueSnackbar("El título es obligatorio", { variant: "error" });
      errors = true
    }

    if(formValues.date == null){
      enqueueSnackbar("La fecha es obligatoria", { variant: "error" });
      errors = true
    }

    return errors;
  }


  const handleSubmit = () => {
    console.log(formValues);

    const formValuesWithTranslations = {
      ...formValues,
      translations: translations
    };

    const formData = new FormData();
    formData.append("formValues", JSON.stringify(formValuesWithTranslations));

    //AXIOS
    axios
      .post(ProjectConfig.api_url, formData, {
        params: {
          request: "add_edit_celebraciones",
        },
      })
      .then((response) => {
        console.log(response);
        if(response.data){
          navigate("/admin/celebraciones");
        }else{
          enqueueSnackbar("Error al guardar", { variant: "error" });
        }
      })
      .catch((err) => {
        console.log(err.data);
      });


  }
  /*====================================
  =====================================*/







  return (
      <div id="userForm">
        <div className="userForm_right">
          <Box id="celebracion_editor" className="box_editor" title="Celebración" subtitle="Editar"  >

            <LangTabs 
              currentLangId={currentLangId} 
              onChange={handleLangChange} 
            />

            <TextField 
              id="title"
              name="title"
              label="Título"
              type="text"
              required
              fullWidth
              value={getCurrentTitle()}
              onChange={handleTitleChange}
            />

            {currentLangId === "1" && (
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <MobileDatePicker
                label="Fecha de la celebración"
                inputFormat="DD/MM/YYYY"
                value={formValues.date}
                InputProps={{
                  endAdornment: (
                    <EventIcon />
                  ),
                }}
                showToolbar={false}
                closeOnSelect
                onChange={(newValue) => {
                  setFormValues({
                    ...formValues,
                    ["date"]: (newValue).format('YYYY-MM-DD')
                  });
                }}
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
            </LocalizationProvider>
            )}





            <App 
              handleEditorChange={handleEditorChange} content={initialContent} 
              key={currentLangId} // Force re-render when language changes
            />
                      

                
            <div className='buttons'>
              <Button onClick={() => navigate(-1)} variant="outlined" className="button_2">Cancelar</Button>
              <Button onClick={() => {
                if (!checkForm()) {
                  handleSubmit()
                }
              }}
              variant="contained"
              className="button_1"
            >
              Guardar
            </Button>
            </div>
          </Box>
        </div>

        
          


      </div>
    
  );
})